// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--wDSvk6cAKw11b67K"};